<div class="background">
  <div class="wide-card">
    <div class="content-holder">
      <p class="body-bold-20">{{'general.create_an_account' | translate}}</p>
      <p class="bordered"></p>
      <form class="flex-form" [formGroup]="registerForm" (ngSubmit)="submit()">
        <div class="inline-forms">
          <div class="form-outline ">
            <app-text-input
              id="firstName"
              name="firstName"
              [label]="'general.firstname' | translate"
              [errorMessage]="'errors.invalid_firstname' | translate"
              [showError]="(firstName.invalid || errorMessages?.FirstName) && formSubmitAttempt"
              formControlName="firstName">
            </app-text-input>
            <ng-container *ngFor="let message of errorMessages?.FirstName | slice: 0:1">
              <span class="error-text">{{message}}</span>
            </ng-container>
          </div>
          <div class="form-outline">
            <app-text-input
              id="lastName"
              name="lastName"
              [label]="'general.lastname' | translate"
              [errorMessage]="'errors.invalid_lastname' | translate"
              [showError]="(lastName.invalid || errorMessages?.LastName) && formSubmitAttempt"
              formControlName="lastName">
            </app-text-input>
            <ng-container *ngFor="let message of errorMessages?.LastName | slice: 0:1">
              <span class="error-text">{{message}}</span>
            </ng-container>
          </div>
        </div>
        <div class="inline-forms">
          <div class="form-outline ">
            <app-text-input
              id="email"
              name="email"
              type="email"
              [label]="'general.email' | translate"
              [errorMessage]="'errors.invalid_email' | translate"
              [showError]="(email.invalid || errorMessages?.Email) && formSubmitAttempt"
              formControlName="email">
            </app-text-input>
            <ng-container *ngFor="let message of errorMessages?.Email | slice: 0:1">
              <span class="error-text">{{message}}</span>
            </ng-container>
          </div>
          <div class="form-outline">
            <label for="phone">{{'general.phone' | translate}}</label>
            <my-phone [formGroup]="registerForm">
            </my-phone>
          </div>
        </div>
        <div class="inline-forms">
          <div class="form-outline">
            <app-text-input
              id="password"
              name="password"
              type="password"
              [label]="'general.password' | translate"
              [enablePasswordToggle]="true"
              [errorMessage]="'errors.invalid_password' | translate"
              [showError]="(password.invalid || errorMessages?.Password) && formSubmitAttempt"
              formControlName="password">
            </app-text-input>
            <ng-container *ngFor="let message of errorMessages?.Password | slice: 0:1">
              <span class="error-text">{{message}}</span>
            </ng-container>
          </div>
          <div class="form-outline">
            <app-text-input
              id="confirmPassword"
              name="confirmPassword"
              type="password"
              [label]="'general.confirm_password' | translate"
              [enablePasswordToggle]="true"
              [errorMessage]="'errors.invalid_password' | translate"
              [showError]="(confirmPassword.invalid || registerForm.hasError('passwordMatch') || errorMessages?.ConfirmPassword) && formSubmitAttempt"
              formControlName="confirmPassword">
            </app-text-input>
            <span *ngIf="formSubmitAttempt && confirmPassword.valid && registerForm.hasError('passwordMatch')"
              class="error-text">
              {{'errors.passwords_dont_match' | translate}}
            </span>
            <ng-container *ngFor="let message of errorMessages?.ConfirmPassword | slice: 0:1">
              <span class="error-text">{{message}}</span>
            </ng-container>
          </div>
        </div>
        <div class="form-outline flex center">
          <button type="submit" class="primary-blue-500 full-width" id="signin-button" [disabled]="isSubmitting">
            <span *ngIf="isSubmitting" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
            {{'general.continue' | translate}}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
